import { SectionsTreeNode } from '../types';

export const findNodeAndIndexByPageId = (
  nodes: SectionsTreeNode[],
  targetPageId: string
): { index: number; node: SectionsTreeNode } | null => {
  for (const node of nodes) {
    if (node.pageIds) {
      const index = node.pageIds.indexOf(targetPageId);
      if (index !== -1) {
        return { index, node };
      }
    }

    if (node.children) {
      const result = findNodeAndIndexByPageId(node.children, targetPageId);
      if (result) return result;
    }
  }

  return null;
};
